// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footerDiv {
  font-family: "Hind Guntur", sans-serif;
  position: fixed;
  top: 94.5%;
  margin-left: 0vw;
  height: 6%;
  font-weight: 500;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  padding-top: 1.5vh;
  background-color: #050505;
}

@media only screen and (max-height: 950px) {
  .footerDiv {
    font-family: "Hind Guntur", sans-serif;
    position: fixed;
    top: 92.5%;
    margin-left: 0vw;
    height: 8%;
    font-weight: 500;
    box-sizing: border-box;
    padding-top: 1.5vh;
    justify-content: center;
    width: 100%;
    background-color: #050505;
  }
}
@media only screen and (max-width: 384px) {
  .footerDiv {
    padding-left: 9%;
    text-align: center;
    font-family: "Hind Guntur", sans-serif;
    position: fixed;
    top: 92.5%;
    margin-left: 0vw;
    /* height:2vh; */
    font-weight: 500;
    box-sizing: border-box;
    padding-top: 2vh;
    justify-content: center;
    width: 100%;
    background-color: #050505;
  }
}
@media only screen and (max-height: 384px) {
  .footerDiv {
    padding-left: 1%;
    text-align: center;
    justify-content: center;
    font-family: "Hind Guntur", sans-serif;
    position: fixed;
    top: 92.5%;
    margin-left: 0vw;
    font-weight: 500;
    box-sizing: border-box;
    padding-top: 0.22vh;
    width: 100%;
    background-color: #050505;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/styles.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE;IACE,sCAAsC;IACtC,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,sCAAsC;IACtC,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,yBAAyB;EAC3B;AACF","sourcesContent":[".footerDiv {\n  font-family: \"Hind Guntur\", sans-serif;\n  position: fixed;\n  top: 94.5%;\n  margin-left: 0vw;\n  height: 6%;\n  font-weight: 500;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 100%;\n  padding-top: 1.5vh;\n  background-color: #050505;\n}\n\n@media only screen and (max-height: 950px) {\n  .footerDiv {\n    font-family: \"Hind Guntur\", sans-serif;\n    position: fixed;\n    top: 92.5%;\n    margin-left: 0vw;\n    height: 8%;\n    font-weight: 500;\n    box-sizing: border-box;\n    padding-top: 1.5vh;\n    justify-content: center;\n    width: 100%;\n    background-color: #050505;\n  }\n}\n@media only screen and (max-width: 384px) {\n  .footerDiv {\n    padding-left: 9%;\n    text-align: center;\n    font-family: \"Hind Guntur\", sans-serif;\n    position: fixed;\n    top: 92.5%;\n    margin-left: 0vw;\n    /* height:2vh; */\n    font-weight: 500;\n    box-sizing: border-box;\n    padding-top: 2vh;\n    justify-content: center;\n    width: 100%;\n    background-color: #050505;\n  }\n}\n@media only screen and (max-height: 384px) {\n  .footerDiv {\n    padding-left: 1%;\n    text-align: center;\n    justify-content: center;\n    font-family: \"Hind Guntur\", sans-serif;\n    position: fixed;\n    top: 92.5%;\n    margin-left: 0vw;\n    font-weight: 500;\n    box-sizing: border-box;\n    padding-top: 0.22vh;\n    width: 100%;\n    background-color: #050505;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
